import styled from 'styled-components';

export const PostTitle: any = styled.h2`
  position: relative;
  text-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  margin-bottom: 0.75rem;
  word-break: break-all;
`;
